'use strict';

angular.module('youth').controller('HomeTrackerCtrl', ['$scope', 'trackerSvc', function ($scope, trackerSvc) {
  trackerSvc.getRecent().then(function (res) {
    $scope.events = res.data;
  });
}]);